module.exports = __webpack_public_path__ + "public/images/purple_arrow_m.ff86d838833db0d524e96da04dcc28cf.webp";